var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiningroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1254 10.1979C12.4016 10.1979 12.6254 10.4218 12.6254 10.6979V16.7489C12.6254 17.025 12.4016 17.2489 12.1254 17.2489C11.8493 17.2489 11.6254 17.025 11.6254 16.7489V10.6979C11.6254 10.4218 11.8493 10.1979 12.1254 10.1979Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66795 10.6979C7.66795 10.4218 7.89181 10.1979 8.16795 10.1979H16.0829C16.3591 10.1979 16.5829 10.4218 16.5829 10.6979C16.5829 10.9741 16.3591 11.1979 16.0829 11.1979H8.16795C7.89181 11.1979 7.66795 10.9741 7.66795 10.6979Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4593 16.7489C10.4593 16.4727 10.6831 16.2489 10.9593 16.2489H13.2885C13.5646 16.2489 13.7885 16.4727 13.7885 16.7489C13.7885 17.025 13.5646 17.2489 13.2885 17.2489H10.9593C10.6831 17.2489 10.4593 17.025 10.4593 16.7489Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7572 12.1696H19.613V14.6212H14.5346V13.5524C14.5369 13.2153 14.6463 12.8771 14.8607 12.6141C15.0774 12.3483 15.3951 12.1715 15.7546 12.1696L15.7572 12.1696ZM15.7592 13.1696C15.7367 13.1699 15.689 13.1807 15.6358 13.246C15.5799 13.3145 15.5358 13.4254 15.5346 13.5578V13.6212H18.613V13.1696H15.7592Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1131 8.13542C19.3892 8.13542 19.6131 8.35928 19.6131 8.63542V16.7923C19.6131 17.0685 19.3892 17.2923 19.1131 17.2923C18.8369 17.2923 18.6131 17.0685 18.6131 16.7923V8.63542C18.6131 8.35928 18.8369 8.13542 19.1131 8.13542Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0346 13.3366C15.3108 13.3366 15.5346 13.5605 15.5346 13.8366V16.7923C15.5346 17.0685 15.3108 17.2923 15.0346 17.2923C14.7585 17.2923 14.5346 17.0685 14.5346 16.7923V13.8366C14.5346 13.5605 14.7585 13.3366 15.0346 13.3366Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29071 14.1097V14.6097H4.70296V12.158H8.56186C8.92457 12.158 9.24525 12.3362 9.46321 12.6047C9.67886 12.8703 9.78761 13.2121 9.78761 13.5519V14.1097H9.29071ZM8.78761 13.6097V13.5519C8.78761 13.4177 8.74342 13.3047 8.68686 13.235C8.63262 13.1682 8.58411 13.158 8.56186 13.158H5.70296V13.6097H8.78761Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21192 8.13542C5.48806 8.13542 5.71192 8.35928 5.71192 8.63542V16.7923C5.71192 17.0685 5.48806 17.2923 5.21192 17.2923C4.93578 17.2923 4.71192 17.0685 4.71192 16.7923V8.63542C4.71192 8.35928 4.93578 8.13542 5.21192 8.13542Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29069 13.3366C9.56683 13.3366 9.79069 13.5605 9.79069 13.8366V16.7923C9.79069 17.0685 9.56683 17.2923 9.29069 17.2923C9.01455 17.2923 8.79069 17.0685 8.79069 16.7923V13.8366C8.79069 13.5605 9.01455 13.3366 9.29069 13.3366Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66908 8.43626H12.7041L12.3528 10.8319H10.0258L9.66908 8.43626ZM10.829 9.43626L10.8879 9.83192H11.4887L11.5468 9.43626H10.829Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2539 9.13409H14.3479L14.0989 10.8319H12.5029L12.2539 9.13409Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiningroom);
export default __webpack_public_path__ + "static/media/diningroom.255658f6a7752571880416a7f69e5a04.svg";
export { ForwardRef as ReactComponent };